export const PLINKO_GAME_LIGHTNING_BOARD = '/plinko-game/lightningBoard'
export const PLINKO_GAME_LIVE_BETS = '/plinko-game/liveBets'
